export default __webpack_public_path__ + "static/media/pantaloncillo-explorador-mujer.1b196e6d.png";